module.exports = __webpack_public_path__ + "img/18-5.220d9499.png";